import { LegalShell } from "./LegalShell";

export default function Returns() {
  return (
    <LegalShell
      title="Returns & Refunds"
      subtitle="We want you obsessed with your dress. Here's exactly what to do if you're not."
      path="/returns"
      updated="February 12, 2026"
      sections={[
        {
          id: "the-promise",
          heading: "Our promise",
          body: (
            <>
              <p>If your dress arrives and doesn't feel right, we'll make it right. We're a small family
              boutique, not a warehouse — call Heather directly and we'll find a solution together.</p>
              <p>The rules below are the formal version so everyone knows what to expect.</p>
            </>
          ),
        },
        {
          id: "window",
          heading: "Return window",
          body: (
            <>
              <p><b>7 days</b> from the day your dress is delivered.</p>
              <p>To start a return, email <a className="text-rosemetal" href="mailto:support@heathersboutique.com">support@heathersboutique.com</a>
              or call the store within 7 days of delivery. Include your order number and a photo.</p>
            </>
          ),
        },
        {
          id: "eligibility",
          heading: "What's returnable",
          body: (
            <>
              <p>A dress is eligible for a full refund if it:</p>
              <ul className="list-disc pl-5 space-y-1.5">
                <li>Is unworn (except for a private fitting)</li>
                <li>Has all original tags attached</li>
                <li>Is free of makeup, deodorant, perfume, or pet hair</li>
                <li>Has not been altered</li>
              </ul>
              <p>We inspect every return upon receipt.</p>
            </>
          ),
        },
        {
          id: "not-returnable",
          heading: "Final sale items",
          body: (
            <>
              <p>The following are non-refundable:</p>
              <ul className="list-disc pl-5 space-y-1.5">
                <li>Altered dresses (custom hemming, bust adjustment, etc.)</li>
                <li>Bespoke or made-to-order pieces</li>
                <li>Sale items marked "Final Sale"</li>
                <li>Accessories worn or with removed tags</li>
                <li>AI Try-On credits and any digital goods</li>
                <li>Gift cards</li>
              </ul>
            </>
          ),
        },
        {
          id: "how-to-return",
          heading: "How to return",
          body: (
            <>
              <ol className="list-decimal pl-5 space-y-1.5">
                <li>Email us within 7 days of delivery to receive a Return Authorization (RA #).</li>
                <li>Package the dress in its original garment bag (or an equivalent breathable bag).</li>
                <li>Include your RA # inside the package.</li>
                <li>Ship via a trackable, insured carrier to the return address we provide.</li>
                <li>We recommend adding shipping insurance for high-value dresses — lost packages without
                insurance are the customer's responsibility.</li>
              </ol>
            </>
          ),
        },
        {
          id: "refund-timing",
          heading: "When you'll see your refund",
          body: (
            <p>Once we receive and inspect the dress, we'll process your refund within <b>5 business days</b>
            to the original payment method. Depending on your bank it may take another 3–10 business days to
            appear on your statement.</p>
          ),
        },
        {
          id: "restocking",
          heading: "Restocking fees",
          body: (
            <>
              <p>None on regular-price returns. If a returned dress arrives worn, tagless, or damaged, we may
              charge a restocking fee up to 25% of the item price or refuse the return outright.</p>
            </>
          ),
        },
        {
          id: "exchanges",
          heading: "Exchanges",
          body: (
            <p>The fastest way to exchange sizes or colors is to place a new order for the piece you want,
            then return the original. This holds your Dress Lock so no one else at your school can grab it
            while you swap.</p>
          ),
        },
        {
          id: "damaged",
          heading: "Damaged in shipping",
          body: (
            <p>If your dress arrives damaged or the wrong item was shipped, contact us within 48 hours and
            we'll ship you a replacement at no cost and pay return shipping on the original. No forms, no
            fuss.</p>
          ),
        },
        {
          id: "chargebacks",
          heading: "A note on chargebacks",
          body: (
            <p>Please talk to us before filing a chargeback with your bank — 9 times out of 10 we can resolve
            the issue faster than the card network can. Chargebacks initiated without prior contact may
            impact future orders.</p>
          ),
        },
      ]}
    />
  );
}
